module.exports = __webpack_public_path__ + "img/T4-A-rc_12.0e61b369.png";